import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { IAgencyMfaCell, IAgencyMfaPolicy } from 'types/mfa/IAgencyMfaPolicy';

const BASE_URL = 'AgencyMfaPolicy';

export const getAgencyMfaPolicy = async (): Promise<IAgencyMfaPolicy> => {
  const response: AxiosResponse<IAgencyMfaPolicy> = await getApi().get(BASE_URL);
  return response.data;
};

export const updateAgencyMfaMatrix = async (cells: IAgencyMfaCell[]): Promise<void> => {
  await getApi().put(BASE_URL, { cells });
};

export const updateAgencyMfaActivationDate = async (activationDate: string | null): Promise<void> => {
  await getApi().put(`${BASE_URL}/ActivationDate`, { activationDate });
};
